function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "audio");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "audio",
  transform: "translate(-5.000000, 0.000000)",
  fill: "#3B3A42"
}, React.createElement("g", {
  transform: "translate(5.000000, 0.000000)"
}, React.createElement("path", {
  d: "M9.1172,0 L8.8832,0 C6.1862,0 4.0002,2.208 4.0002,4.933 L4.0002,14.067 C4.0002,16.792 6.1862,19 8.8832,19 L9.1172,19 C11.8132,19 14.0002,16.792 14.0002,14.067 L14.0002,4.933 C14.0002,2.208 11.8132,0 9.1172,0 M9.1172,2 C10.7072,2 12.0002,3.315 12.0002,4.933 L12.0002,14.067 C12.0002,15.685 10.7072,17 9.1172,17 L8.8832,17 C7.2932,17 6.0002,15.685 6.0002,14.067 L6.0002,4.933 C6.0002,3.315 7.2932,2 8.8832,2 L9.1172,2",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M10,22.9389297 L10,26 L16,26 L16,28 L2,28 L2,26 L8,26 L8,22.9391648 C3.46622646,22.4196147 -0.0409405449,18.6474412 0.000383326256,14.0770972 L0.00100306664,14.0430338 C0.00171347897,13.9956546 0.00171347897,13.9956546 0.0031,13.9739 L0.0031,11.1299 C0.0031,10.5776153 0.45081525,10.1299 1.0031,10.1299 C1.55538475,10.1299 2.0031,10.5776153 2.0031,11.1299 L2.00202009,14.0203614 C2.00137541,14.0377009 2.00137541,14.0377009 2.00075249,14.0746921 L2.00005933,14.1099191 C1.9661003,17.8750178 5.09687392,20.9665926 9.0001,20.9999 L9.04836118,20.9994236 L9.1066514,20.9981989 C13.0175702,20.9025538 16.0949399,17.7632962 15.9971,13.9739 L15.9971,11.1299 C15.9971,10.5776153 16.4448153,10.1299 16.9971,10.1299 C17.5493847,10.1299 17.9971,10.5776153 17.9971,11.1299 L17.9967646,13.9480008 C18.116045,18.5520125 14.5976917,22.4108384 10,22.9389297 Z",
  id: "Combined-Shape",
  fillRule: "nonzero"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "18px",
    height: "28px",
    viewBox: "0 0 18 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/audio.f4a0b86e.svg";
export { SvgComponent as ReactComponent };